import { UserAppRole, UserOrganizationRole } from "./API";
import { SettingsBookkeepingTab } from "./routes/dashboard/settings-bookkeeping/settings-bookkeeping-layout";
import { SettingsOrganizationTab } from "./routes/dashboard/settings-organization/settings-organization-layout";

export const stringBookingAccounts = "Buchungskonten";
export const stringTaxRates = "Steuersätze";
export const stringBookkeepingYears = "Buchungsjahre";

export const stringMapSettingsBookkeepingTab: Map<
  SettingsBookkeepingTab,
  string
> = new Map([
  ["booking-accounts", stringBookingAccounts],
  ["tax-rates", stringTaxRates],
  ["bookkeeping-years", stringBookkeepingYears],
]);

export const stringMembers = "Teammitglieder";
export const stringGeneral = "Allgemein";
export const stringFreigaben = "Freigaberegeln";

export const stringMapSettingsOrganizationTab = new Map<
  SettingsOrganizationTab,
  string
>([
  ["allgemein", stringGeneral],
  ["team", stringMembers],
  ["freigaben", stringFreigaben],
  ["bexio", "bexio"],
]);

export const stringMapUserOrganizationRole: Map<UserOrganizationRole, string> =
  new Map([
    [UserOrganizationRole.accountant, "Buchhalter"],
    [UserOrganizationRole.admin, "Administrator"],
    [UserOrganizationRole.employee, "Mitarbeiter"],
    [UserOrganizationRole.head, "Teamleiter"],
  ]);

export const stringMapUserAppRole: Map<UserAppRole, string> = new Map([
  [UserAppRole.accountant, "Buchhalter"],
  [UserAppRole.organizationAdmin, "Organisationsleiter"],
  [UserAppRole.user, "Benutzer"],
]);

export const stringIsDisabled = "Kann nicht bearbeitet werden";

export const stringShowDeleted = "Gelöschte anzeigen";
export const stringShowExported = "Bereits exportierte ausblenden";
